// extracted by mini-css-extract-plugin
export var deliveryRow = "_o8-a";
export var fixedHeight = "_o8-4";
export var freightLogo = "_o8-9";
export var fullWidth = "_o8-3";
export var priceColumn = "_o8-5";
export var radioSelected = "_o8-7";
export var radioUnselected = "_o8-6";
export var selectedOption = "_o8-2";
export var selectedOptionContainer = "_o8-1";
export var selection = "_o8-0";
export var tallSkeletonText = "_o8-8";